import { render } from "./headtable.vue?vue&type=template&id=4c601086"
import script from "./headtable.vue?vue&type=script&lang=js"
export * from "./headtable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/newuser/Herd/spider-project-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__